// extracted by mini-css-extract-plugin
module.exports = {"header":"style-module--header--EICu5","active":"style-module--active--2Sntq","inner":"style-module--inner--18ydR","language":"style-module--language--pAH7h"};